export * from './lib/+state/clients.models';

export * from './lib/+state/clients.reducer';
export * from './lib/+state/clients.actions';
export * from './lib/shared-data-access-clients.module';

import * as SharedClientsSelectors from './lib/+state/clients.selectors';
import * as SharedClientsActions from './lib/+state/clients.actions';

export { SharedClientsSelectors, SharedClientsActions };

export { ClientsService } from './lib/services/clients.service';
